{
    "MENU": {
        "MEMBERSHIP": "Membership",
        "EVERYDAY_CARE": "{{tenant}} Plus: For Everyday Care",
        "HEALTH_SHARE_FOR_LARGE": "HealthShare: For Large Medical Expenses",
        "FOR_MEMBERS": "For our members",
        "EMPLOYERS_BENEFITS": "Employers Benefits",
        "Brokers Benefits": "Brokers Benefits",
        "OFFICE_VISITS": "Office Visits",
        "VIRTUAL_URGENT_CARE": "Virtual Urgent Care",
        "MENTAL_HEALTH": "Mental Health Counseling",
        "PHARMACY": "Pharmacy",
        "DENTAL_CARE": "Dental Care",
        "VISION_CARE": "Vision Care",
        "IMAGING": "Imaging",
        "LAB_TESTS": "Lab Tests",
        "PROCEDURES_SURGERIES": "Procedures & Surgeries",
        "HEALTH_SHARE": "Healthshare",
        "RESOURCES": "资源",
        "FAQ_AND_VIDEOS": "FAQs & Videos",
        "VIDEOS": "Videos",
        "BLOGS": "Blogs",
        "FAQS": "FAQs",
        "ABOUT_US": "About Us",
        "CONTACT_US": "Contact Us",
        "FOR_EMPLOYERS": "For Employers",
        "FOR_BROKERS": "For Brokers",
        "REGISTER": "Join Now",
        "REGISTER_INFO": "Don’t have an account?",
        "MEMBERLOGIN": "Member login",
        "ACCOUNT": "我的账户",
        "FAMILY": "Family Info",
        "Wallet": "Wallet",
        "Dashboard": "Visit Dashboard",
        "LOGOUT": "退出登录",
        "LOGIN": "Login",
        "LOGIN_INFO": "Already have an account?"
    },
    "FOOTER": {
        "APPINFOTITLE": "Take control of your healthcare with our easy to use app",
        "DESCRIPTION": "Enjoy unlimited healthcare savings at {{tenant}}. Our memberships are affordable and easy to access with transparent pricing.",
        "SIGNUP_AS": "Sign up as",
        "EMPLOYERS": "Employers",
        "PROVIDER": "Provider",
        "DISCLAIMER_TITLE": "Disclaimer:",
        "DISCLAIMER_DESCRIPTION": "We are not health insurance. Our membership program offers discounted healthcare services for a monthly fee. Members pay providers directly at the time of service. This is not a substitute for insurance and does not meet ACA requirements."
    },
    "LOGINFORM": {
        "TITLE": "Log in to your account",
        "DESCRIPTION": "Welcome back! Please enter your details.",
        "LABEL_EMAIL": "Email",
        "EMAIL_ERROR": "Please enter your email",
        "EMAIL_VALID": "Please enter a valid email.",
        "LABEL_PASSWORD": "Password",
        "PASSWORD_ERROR": "Please enter your password",
        "LABEL_FORGOT": "Forgot password?",
        "LABEL_REMEMBER": "Remember me",
        "LABEL_SUBMIT": "Sign in",
        "INVALID_CREDENTIALS_ERROR": "Invalid credentials!",
        "NO_ACCOUNT": "Don’t have an account?",
        "BECOME_MEMBER": "Join Now",
        "CONTENT": "Welcome!",
        "PARA": "The {{tenant}} member portal is your one-stop-shop for accessing all of your health care services and benefits. ",
        "CONTENT_MEMBER": "Set up and access your member account: ",
        "MDISCRIPTION": "If you are a new member and have not set up your online account, <a href='/' class='start-here-link'>start here</a>.  You will be guided to complete your member profile and if applicable, designate your dependents. ",
        "LOGIN_MEMBER": "Log In:",
        "LOGINPARA": "Enter your email and password and Sign In to access your member dashboard. All included services in your {{tenant}} membership will be listed on your dashboard. "
    },
    "FORGOTPASSWORDFORM": {
        "EMAIL_FIELD": "Email",
        "EMAIL_REQUIRED": "Please enter your email.",
        "EMAIL_PATTERN": "Please enter a valid email."
    },
    "REGISTERFORM": {
        "HEADING": "Signup for {{tenant}}",
        "SUB_HEADING": "Become Our Member",
        "FIRST_NAME": "名",
        "FIRST_NAME_ERROR": "Please enter first name",
        "LAST_NAME": "姓",
        "LAST_NAME_ERROR": "Please enter last name",
        "NAME_HELPER_TEXT": "This will appear on your membership card",
        "PASSWORD_HELPER_TEXT": "Use 12 or more characters with a mix of letters (upper & lower), numbers, and symbols.",
        "HOW_DID_YOU_HEAR": "How did you hear about us?",
        "EMAIL": "Email",
        "EMAIL_PLACEHOLDER": "johndoe@abc.com",
        "EMAIL_ERROR": "Please enter your email",
        "EMAIL_VALID": "Please enter a valid email.",
        "PHONE": "Phone",
        "PHONE_ERROR": "Please enter your phone number",
        "PHONE_ERROR_LENGTH": "Length must not be greater than 10",
        "DOB": "Date of Birth",
        "DOB_ERROR": "Please enter date of birth",
        "DOB_AGE_ERROR": "Age should be greater than 18",
        "FUTURE_DATE": "Cannot be a future date",
        "CHILD_DOB_VALID": "Child should not be older than 26",
        "DOB_VALID": "Please enter date in proper pattern",
        "GENDER": "Gender",
        "GENDER_ERROR": "Please select gender",
        "REFERRAL": "How did you hear about us?",
        "REFERRAL_ERROR": " Please select How did you hear about us?",
        "TIMEZONE": "Time zone",
        "TIMEZONE_ERROR": "Please select your timezone.",
        "PASSWORD": "Password",
        "PASSWORD_ERROR": "Please enter password",
        "PASSWORD_ERROR_PATTERN": "Password should be Atleast one upper case letter, one lower case letter, one Number , one Special Character, Minimum 12 and Maximum 20 characters in limit",
        "PASSWORD_MINIMUM_LENGTH": "Length should be atleast 8 characters",
        "PASSWORD_REQUIREMENTS": "Use 12 or more characters with a mix of letters (upper & lower), numbers, and symbols.",
        "CONFIRM_PASSWORD": "Confirm Password",
        "CONFIRM_PLACEHOLDER": "Re enter-Password",
        "CONFIRM_PASSWORD_ERROR": "Please confirm your password",
        "CONFIRM_PASSWORD_MATCH": "Passwords do not match",
        "TERMS_VALIDATION": "Please agree to terms and conditions.",
        "SIGN_UP_BTN": "Sign Up & Proceed to Pay",
        "CREATE_ACC_TITLE": "Create your account",
        "CONFIRM_EMAIL_TITLE": "Confirm your email",
        "CREATE_ACC_DESC": "Complete the online registration form with your personal details to create your {{tenant}} member account. This will enable you to manage your plan, dependents, and services.",
        "CONFIRM_EMAIL_DESC": "After registering, check your email inbox for a confirmation message. Click the link to verify and activate your account.",
        "LOGIN_DESC": "After email confirmation, return to the login page with your email and password to access your member dashboard. If you already have an account, <a href='/' class='start-here-link'>click here</a> to log in."
    },
    "RESETPASSWORD": {
        "HEADING": "Create Password",
        "SUB_HEADING": "Select a new password for future logins.",
        "PASSWORD_REQUIRED": "Please enter your password",
        "CONFIRM_PASSWORD_REQUIRED": "Please enter your confirm password"
    },
    "ACTIVATEACCOUNT": {
        "TITLE": "Set Up Your Login",
        "DESCRIPTION": "Enter the email address and password you'll use to sign in to your account.",
        "EMAIL_LABEL": "Email Address",
        "EMAIL_PLACEHOLDER": "yourname@example.com",
        "EMAIL_REQUIRED": "Email address is required",
        "EMAIL_VALID": "Please enter a valid email address",
        "EMAIL_EXAMPLE_INVALID": "Please enter your own email address; example.com is not allowed.",
        "EMAIL_HINT": "You will use this email to login to your account.",
        "PASSWORD_LABEL": "Password",
        "PASSWORD_PLACEHOLDER": "Create a password",
        "PASSWORD_REQUIRED": "Password is required",
        "PASSWORD_PATTERN": "Use at least 12 characters, including letters, numbers, and symbols",
        "CONFIRM_LABEL": "Confirm Password",
        "CONFIRM_PLACEHOLDER": "Re-enter your password",
        "CONFIRM_REQUIRED": "Please confirm your password",
        "CONFIRM_MISMATCH": "Passwords do not match",
        "PASSWORD_HINT": "Use at least 12 characters, including a combination of letters, numbers, and symbols.",
        "SUBMIT_BTN": "Set Up Account",
        "SUPPORT_PREFIX": "Having trouble?",
        "SUPPORT_LINK": "Contact support",
        "MEMBERSHIP_TITLE": "Activate Your Membership",
        "MEMBERSHIP_DESC": "Your employer has enrolled you in healthcare benefits. Complete these steps to access your dashboard.",
        "HOW_IT_WORKS": "How it works",
        "STEP_1": "Add your email address",
        "STEP_2": "Create a secure password",
        "STEP_3": "Access your dashboard",
        "VERIFYING_TITLE": "Verifying your activation link...",
        "SETTING_UP_TITLE": "Setting up your account...",
        "PLEASE_WAIT": "Please wait a moment...",
        "SUCCESS_TITLE": "Your Account Is Ready",
        "SUCCESS_DESC": "Your account is ready. You can now sign in using your email address and password.",
        "SIGN_IN_BTN": "Sign In Now",
        "EXPIRED_TITLE": "Verification Link Expired",
        "EXPIRED_DESC": "The link in your text message has expired. Verification links are valid for 72 hours.",
        "EXPIRED_NOTE_TITLE": "Link has expired",
        "EXPIRED_NOTE_DESC": "For your security, verification links expire after 72 hours. Request a new activation link to continue setting up your account.",
        "RESEND_BTN": "Request New Activation Link",
        "EXPIRED_SIDE_TITLE": "Need a new activation link?",
        "EXPIRED_SIDE_DESC": "Request a new link and we'll send it to your registered phone number so you can complete your WoW Health online account setup.",
        "WHAT_HAPPENS_NEXT": "What happens next",
        "NEXT_1": "We'll send a new activation link to your phone",
        "NEXT_2": "Open the link within 72 hours",
        "NEXT_3": "Add your email address",
        "NEXT_4": "Create your password",
        "LINK_SENT_TITLE": "New Activation Link Sent",
        "LINK_SENT_DESC": "A new activation link has been sent to your registered mobile number. Please check your messages and click the link within 72 hours.",
        "CLOSE_BTN": "Close",
        "ERROR_TITLE": "Something Went Wrong",
        "ERROR_DESC": "We were unable to complete your request. Please try again later.",
        "TRY_AGAIN_BTN": "Try Again",
        "SETUP_FAILED": "We were unable to set up your account. Please try again."
    },
    "CONTACTUS": {
        "HEADING": "Get In Touch",
        "SUB_HEADING": "We are available to offer our support and respond to any inquiries that you may have. We are excitedly anticipating hearing from you.",
        "NAME": "Name",
        "NAME_ERROR": "Please enter name",
        "FIRST_NAME": "名",
        "FIRST_NAME_ERROR": "The field is required.",
        "LAST_NAME": "姓",
        "LAST_NAME_ERROR": "The field is required.",
        "SUBJECT": "Subject",
        "SUBJECT_PLACEHOLDER": "How can we help you?",
        "SUBJECT_ERROR": "The field is required.",
        "EMAIL": "Email Address",
        "EMAIL_ONLY": "Email",
        "EMAIL_PLACEHOLDER": "Johndoe@gmail.com",
        "EMAIL_ERROR": "The field is required.",
        "EMAIL_VALID": "Please enter a valid email.",
        "PHONE": "Phone Number",
        "PHONE_PLACEHOLDER": "9832314233",
        "PHONE_ERROR": "The field is required.",
        "MESSAGE": "Message",
        "MESSAGE_ERROR": "Please enter message",
        "MESSAGE_PLACEHOLDER": "Enter your thoughts here",
        "TERMS_VALIDATION": "Please agree to terms and conditions.",
        "SEND_MESSAGE": "Send Message",
        "SUCCESS_MSG": "Thank you for your message it has been sent",
        "LICENSED": "Are you a licensed broker or agent?",
        "LICENSED_ERROR": "Please select an option.",
        "YES": "Yes",
        "NO": "No"
    },
    "PROFILE": {
        "HEADING": "你好",
        "SUBHEADING": "欢迎来到您的 {{tenant}} 仪表盘",
        "TOUR": {
            "HEADING_ONE": "欢迎来到 {{tenant}}",
            "HEADING": "使用方法",
            "DESCRIPTION": "如果您需要帮助了解如何使用仪表盘，请观看此视频",
            "RESTART_TOUR": "重新开始导览",
            "WATCH_VIDEO": "观看视频",
            "DESCRIPTION_ONE": "快速浏览一下，了解如何轻松获取您的各项医疗福利",
            "START_TOUR": "重新开始导览",
            "SKIP_TOUR": "跳过导览"
        },
        "STEP1": {
            "HEADING": "Add your personal information",
            "SUB_HEADING": "Enter your address, zip code, phone number, etc.",
            "FIRST_NAME": "名",
            "LAST_NAME": "姓",
            "EMAIL": "Email",
            "PHONE": "Phone number",
            "DOB": "Date of Birth",
            "GENDER": "Gender",
            "ADDRESS": "Address",
            "CITY": "City",
            "STATE": "State",
            "COUNTRY": "Country",
            "ZIPCODE": "Zip Code",
            "TIMEZONE": "Time Zone",
            "SUBMIT_BTN": "Submit",
            "CONTINUE_BTN": "Save & Proceed",
            "FINISH_BTN": "Finish"
        },
        "STEP2": {
            "HEADING": "Choose your plan type",
            "SUB_HEADING": "Select a plan type to proceed",
            "SELECT_MEMBERSHIP_TYPE": "Select the membership type",
            "INDIVIDUAL": "Individual",
            "SPOUSE": "Spouse",
            "FAMILY": "Family",
            "CHILDREN": "Children",
            "SUBMIT_BTN": "Submit",
            "CONTINUE_BTN": "Save & Proceed",
            "FINISH_BTN": "Finish"
        },
        "STEP3": {
            "HEADING": "Add your spouse information",
            "SUB_HEADING": "Add name, email, date of birth, etc",
            "FIRST_NAME": "名",
            "LAST_NAME": "姓",
            "EMAIL": "Email",
            "DOB": "Date of Birth",
            "GENDER": "Gender",
            "SUBMIT_BTN": "Submit",
            "CONTINUE_BTN": "Save & Proceed",
            "FINISH_BTN": "Finish",
            "ACCESS": "允许配偶访问账户",
            "TOOLTIP": "若父母双方均拥有访问权限，可共同管理未成年人的医疗账户；否则，仅主要家长账户拥有访问权限。"

        },
        "STEP4": {
            "HEADING": "Add your child(ren) information",
            "SUB_HEADING": "Add your child(ren) information",
            "ACCESS": "允许配偶访问账户",
            "FIRST_NAME": "名",
            "LAST_NAME": "姓",
            "EMAIL": "Email",
            "DOB": "Date of Birth",
            "GENDER": "Gender",
            "SUBMIT_BTN": "Submit",
            "CONTINUE_BTN": "Save & Proceed",
            "FINISH_BTN": "Finish",
            "ADD_ANOTHER_BTN": "Add Another",
            "REMOVE_BTN": "Delete"
        },
        "SUCCESS": {
            "HEADING": "Thank you!",
            "CONTENT": "You have successfully updated your profile. Please note that your membership will start on {{date}}. After that date, you will be able to fully access all of the membership services and benefits",
            "BTN_TEXT": "Go to Dashboard"
        },
        "ERROR": {
            "GENERIC": "This is required",
            "EMAIL": "Please enter a valid email.",
            "TOTAL_PHONE_LENGTH": "Phone number to have 10 digits"
        }
    },
    "NAVBAR": {
        "DASHBOARD": "仪表盘",
        "APPOINTMENTS": "预约",
        "MEMBERSHIPS": "会员资格",
        "RESOURCES": "资源",
        "WALLET": "钱包",
        "FAMILY_INFO": "家庭信息",
        "ACCOUNT": "Account",
        "MYACCOUNT": "我的账户",
        "VISITEWEB": "访问网站",
        "LOGOUT": "退出登录"
    },
    "SEARCH_COMPONENT": {
        "BUTTON": "Search",
        "INFO": "We were unable to find any results for ",
        "HELPTEXT": "Please check spelling and pick from drop down."
    },
    "DASHBOARD": {
        "BTN_TEXT": "加入 {{tenant}} 会员",
        "WELLNESS": {
            "NEED_HELP": "需要帮助？",
            "LEARN_MORE": "了解更多",
            "WELLNESS_REWARD": "健康奖励"
        }
    },
    "SAVE": "Save payment method",
    "tenant": "{{tenant}} ENGLISH",
    "LOW_BALANCE": "{{tenant}} 钱包余额不足",
    "GO_BACK": "Go back to {{tenant}}",
    "image": "assets/tenant-assets/images/healtthshare-main.webp",
    "homepage_title": "Home Page Content",
    "APP_TITLE": "{{tenant}}",
    "GO_BACK_BTN": "Go Back",
    "CONTINUE_BTN": "Continue",
    "TRUSTED_PARTNERS": "Our Trusted Partners",
    "EMAIL_SENT": "Email has been sent successfully!",
    "CVV_ERR": "CVV should be between 3 to 4 numbers",
    "CARDHOLDER_ERR": "Card display name should be in 'Fullname' format",
    "ZIPCODE_REQUIRED": "Zipcode is required",
    "ZIPCODE_ERR": "Zipcode should be of 5 numbers",
    "EXPIRY_ERR": "Please Enter valid Expiry Date",
    "CARDNUMBER_ERR": "Card Number should be between 13 to 16 numbers",
    "DELETE": "Delete",
    "ALREADY_MEMBER": "Already a member?",
    "SIGN_IN": "Sign in",
    "MEMBERSHIP_WARNING": "Important! Regarding your membership start date",
    "PAYMENT_DETAILS": "Payment Details",
    "EXPIRY_FUTURE_ERR": "Expiry must be in the future.",
    "SAVE_CARD": "Use this card for future transactions",
    "SECURED_PAYMENT": "This payment is secured with SSL encryption.",
    "ALERTBOXCOMPONENT": {
        "HEADING": "Important! Regarding your membership start date",
        "SUBHEADING1": "Please note that your membership will start on",
        "SUBHEADING2": "After that date, you will be able to fully access all of the membership services and benefits."
    },
    "FAMILY_INFO": {
        "ADD_NEW_MEMBERSHIP": "添加新成员",
        "ADD_NEW_MEMBER": "添加新成员",
        "ADD_NEW_MEMBER_DESC": "添加新成员，并将其直接关联到所选会员计划。",
        "FORM": {
            "FIRST_NAME": "名",
            "LAST_NAME": "姓",
            "GENDER": "性别",
            "RELATION": "关系",
            "DATE_OF_BIRTH": "出生日期",
            "EMAIL": "电子邮箱",
            "SPOUSE_ACCESS": "允许配偶访问账户",
            "TOOLTIP": "若父母双方均拥有访问权限，可共同管理未成年人的医疗账户；否则，仅主要家长账户拥有访问权限。",
            "SAVE_BTN": "保存",
            "DISCARD_BTN": "取消",
            "ERROR": {
                "GENERIC": "此字段是必需的。.",
                "EMAIL": "Please enter a valid email.",
                "SPOUSE_DOB_VALID": "Spouse should be older than 18",
                "CHILD_DOB_VALID": "Child should not be older than 26",
                "DOB_PATTERN": "Pattern should be valid",
                "FUTURE_DATE": "Cannot be a future date"
            }
        }
    },
    "TOUR": {
        "STEP1": {
            "TITLE": "体验 {{tenant}} 的实际功能",
            "TEXT": "想快速了解吗？观看这段简短视频，了解 {{tenant}} 的工作方式，以及如何充分利用各项服务。"
        },
        "STEP2": {
            "TITLE": "您的仪表板，由您掌控",
            "TEXT": "这是您的主仪表板。只需点击您需要的服务即可。"
        },
        "STEP3": {
            "TITLE": "预约并管理您的就诊",
            "TEXT": "查看、预约并管理您所有过去和即将到来的就诊安排，无需再为繁琐的纸质流程烦恼。"
        },
        "STEP4": {
            "TITLE": "灵活的会员方案",
            "TEXT": "根据您的需求轻松调整会员方案。您的医疗保障，由您自己选择。"
        },
        "STEP5": {
            "TITLE": "所有答案尽在一处",
            "TEXT": "有任何疑问？前往 Resources（资源） 页面，即可获得即时帮助以及有关 {{tenant}} 的详细信息。"
        },
        "NEXT_BTN": "下一步",
        "DONE_BTN": "知道了 开始使用"
    },
    "WARNINGMODAL" : {
    "HEADING" : "Your Healthcare Benefits Are Available at ",
    "POINT1" : "Please click the button below to visit ",
    "POINT2" : "Log in to your account with the same username and password",
    "POINT3" : "Access your dashboard",
    "POINT4" : "Pick any healthcare service that you need",
    "BTNTXT" : "Go to",
    "HRA_HEADING" : "Personalize Your Wellness Experience",
    "HRA_DETAIL" : "To continue, please complete this 2-minute Health Risk Assessment (HRA). Your responses will help us personalize your wellness benefits and help you get the most from your plan.",
    "HRA_BTN" : "Proceed to Assessment"
  },
  "INCOMPLETE_PROFILE" : {
    "HEADING" : "重要！关于会员资料未完善",
    "DETAIL_PRIMARY" : "您的会员资料尚未完善。请完成资料，以便使用您的医疗保健服务。",
    "DETAIL_SECONDARY" : "主会员的个人资料尚未完善。在更新之前，服务不可用。",
    "COMPLETE_PROFILE_BUTTON" : "完成个人资料",
    "CONTACT_SUPPORT_BUTTON" : "联系支持"
  }
}